require('./myProfileSecurityKitChangeSubmitView.scss');
//@vendor
const React = require('react');
const PropTypes = require('prop-types');
//@commons
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { formatText } = require('core/i18n').i18n;

class MyProfileSecurityKitChangeSubmitView extends React.PureComponent {
    render () {
      return (
          <div>
              <div className="container-fluid">
                  <div className="row">
                      <OKCover size="medium" section="pg" customClass="col-xs-12">
                          <OKHeaderSubPage
                              breadcrumbConfig={[]}
                              finalTitle={formatText('securityKit-titleSubmitView')}
                          />
                      </OKCover>
                  </div>
              </div>
              <div className="grid-view__body grid-view--content-position-negative my-profile-security-kit-change-submit">
                  {this.props.children}
              </div>
          </div>
      )
    }
}

MyProfileSecurityKitChangeSubmitView.propTypes = {
    children: PropTypes.any
};

module.exports = MyProfileSecurityKitChangeSubmitView;
